module.exports = __webpack_public_path__ + "static-portal/img/news13-1.d181f56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news13-1.jpg
// module id = oQEW
// module chunks = 4